import fx from "utils/fx";
import AxiosInterceptor from "api/interceptor";

const vivino = new AxiosInterceptor();

export default {
  getVivino(qstr = {}) {
    qstr = fx.urlQueryString(qstr, false);
    return vivino.get("/vivino-products?" + qstr);
  },
  updateVivino(id, inputs) {
    return vivino.put(`/vivino-products/${id}`, inputs);
  },
  reFreshVivino() {
    return vivino.post(`/vivino-products/refresh`);
  },
  updateLimitVivino(data) {
    return vivino.put("/vivino-products/stock-limit", data);
  }
};
